module.exports = __webpack_public_path__ + "img/Logo_CMYK_red_bgr.29c3a4e1.jpg";